import { UploadOutlined, CopyOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Upload, Image, message } from "antd";
import React, { useEffect, useState } from "react";
import { notify } from "../customs/NotifyProvider";
import { ProductServices } from "../Services/ProductServices";
import { ENDPOINTS } from "../Services/ENDPOINTS";

const UploadPage = () => {
  const [fileList, setFileList] = useState([]);
  const [imageGallery, setImageGallery] = useState([]);

  const getImageGallerty = async () => {
    try {
      const response = await ProductServices.getAllImageGallery();

      if (Array.isArray(response?.data)) {
        const formattedFiles = response.data.map((item) => ({
          uid: item.id,
          name: item.file_path.split("/").pop(),
          status: "done",
          url: `${ENDPOINTS.cleanBase}${item.file_path}`,
        }));

        setFileList(formattedFiles);
        setImageGallery(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getImageGallerty();
  }, []);

  const handleUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("upload_img", file);
    formData.append("file_path", "assets/image_gallery");

    try {
      const response = await ProductServices.uploadImageGallery(formData);

      if (response?.status && response?.data?.file_path) {
        const imageUrl = `${ENDPOINTS.cleanBase}${response.data.file_path}`;
        setFileList((prev) => [
          ...prev,
          { uid: file.uid, name: file.name, status: "done", url: imageUrl },
        ]);
        notify.success("Image uploaded successfully");
        onSuccess(response);
        getImageGallerty();
      } else {
        notify.warning(response?.message || "Upload failed");
        onError(new Error("Upload failed"));
      }
    } catch (error) {
      console.error(error);
      notify.error("Image upload failed");
      onError(error);
    }
  };

  const handleDeleteImage = async (url, rowData) => {
    try {
      const baseUrl = `${ENDPOINTS.cleanBase}/assets/image_gallery/`;
      if (!url?.startsWith(baseUrl)) {
        notify.error("Invalid image URL");
        return;
      }

      const fileName = url.split("/").pop();
      const response = await ProductServices.deleteUploadedFile({
        file_path: "assets/image_gallery",
        file_name: fileName,
      });

      const delete_image = await ProductServices.deleteImageGallery(rowData.id);

      if (response?.status && delete_image?.status) {
        notify.success("Image deleted successfully");
        getImageGallerty();
      } else {
        notify.warning(response?.message, delete_image?.message || "Delete failed");
        getImageGallerty();
      }
    } catch (error) {
      console.error(error);
      getImageGallerty();
      notify.error("Failed to delete image");
    }
  };

  // const handleCopy = (url) => {
  //   navigator.clipboard.writeText(url);
  //   notify.success("Image URL copied to clipboard");
  // };

  const handleCopy = async (url) => {
  try {
    // HTTPS / Secure Context
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
    } else {
      // HTTP / Fallback
      const textarea = document.createElement("textarea");
      textarea.value = url;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const successful = document.execCommand("copy");
      document.body.removeChild(textarea);

      if (!successful) {
        throw new Error("Fallback copy failed");
      }
    }

    notify.success("Image URL copied to clipboard");
  } catch (error) {
    console.error("Copy error:", error);
    notify.error("Failed to copy image URL");
  }
};


  return (
    <Card title="Image Gallery">
      <Upload
        listType="picture"
        fileList={fileList}
        customRequest={handleUpload}
        multiple
        beforeUpload={() => true}
        showUploadList={false} // custom rendering
      >
        <Button icon={<UploadOutlined />}>Upload</Button>
      </Upload>

      <Image.PreviewGroup>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: 16, gap: 16 }}>
          {fileList.map((file) => {
            const rowData = imageGallery.find(
              (item) => `${ENDPOINTS.cleanBase}${item.file_path}` === file.url
            );

            return (
              <div
                key={file.uid}
                style={{
                  width: 120,
                  height: 120,
                  border: "1px solid #d9d9d9",
                  borderRadius: 8,
                  overflow: "hidden",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Antd Image for preview */}
                <Image
                  src={file.url}
                  alt={file.name}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  preview={{ mask: <div /> }} // mask allows default preview
                />

                {/* Action buttons */}
                <div
                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <Button
                    type="primary"
                    size="small"
                    icon={<CopyOutlined />}
                    onClick={() => handleCopy(file.url)}
                  />
                  <Button
                    type="primary"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => handleDeleteImage(file.url, rowData)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </Image.PreviewGroup>
    </Card>
  );
};

export default UploadPage;
